/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_T_TigkeitenInputs */

const de__field_t_tigkeiten = /** @type {(inputs: _Field_T_TigkeitenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tätigkeiten`)
};

/**

* @param {_Field_T_TigkeitenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_t_tigkeiten = /** @type {((inputs?: _Field_T_TigkeitenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_T_TigkeitenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_t_tigkeiten(inputs)
});
export { _field_t_tigkeiten as "_field_tätigkeiten" }